module.exports = {
	"get-/summary-reports/on-demand/summaries": {
		"status": 504,
		"delay": 1000,
		"body": {
			"error": "hello",
			"trace": "stacktrace"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/services/core/mock-responses/data/data.json
// module id = 839
// module chunks = 51